<app-navbar *ngIf="(location == '/')"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="(location == '/')"></app-footer>
